<template>
<div>
    <div class="flex jc-sb ai-c">
        <div class="flex-33">
        </div>

        <div class="flex-33 ta-c">
        </div>

        <div class="flex-33 ta-r">
            <button
                title="Refresh"
                type="button"
                :disabled="is_loading"
                @click="onLoadData">
                <i class="material-icons">refresh</i>
            </button>
        </div>
    </div>

    <div :class="['loading-wrapper', 'mt-4', { loading: is_loading }]">
        <vue-table ref="facilities_table"
            api-url="/api/retired-facilities"
            data-path="data.data"
            pagination-path="data.pagination"
            :http-options="http_options"
            :fields="columns"
            :per-page="100"
            table-height="475px"
            @vuetable:loading="is_loading = true"
            @vuetable:loaded="is_loading = false"
            @vuetable:pagination-data="onPaginationData"
            no-data-template="<span>No facilities to show.</span>">
            <template slot="facility_number" slot-scope="props">
                <div class="flex jc-sb">
                    <span>{{ props.rowData.facility_number }}</span>

                    <span v-if="props.rowData.was_prime" class="prime" title="Prime Facility">
                        <strong>P</strong>
                    </span>
                </div>
            </template>

            <template slot="software" slot-scope="props">
                {{ props.rowData.software }}
            </template>

            <template slot="city" slot-scope="props">
                {{ props.rowData.city }}, {{ props.rowData.state }}
            </template>
        </vue-table>

        <div class="mt-3">
            <vue-table-pagination
                ref="facilities_table_pagination"
                @vuetable-pagination:change-page="onChangePage">
            </vue-table-pagination>
        </div>
    </div>
</div>
</template>

<script>
import http from "@/http"
import store from "@/store"

export default {
    data () {
        return {
            columns: [
                {
                    name: "__slot:facility_number",
                    sortField: "facility_number",
                    title: "Facility Number"
                },
                {
                    name: "__slot:software",
                    title: "Software"
                },
                {
                    name: "__slot:city",
                    title: "City"
                },
                {
                    name: "total",
                    title: "Total Insureds",
                    dataClass: "center aligned",
                    titleClass: "center aligned",
                    width: "150px"
                },
                {
                    name: "charge_applied",
                    title: "Charge Applied",
                    dataClass: "center aligned",
                    titleClass: "center aligned",
                    width: "150px"
                },
                {
                    name: "chose_coverage",
                    title: "Chose Coverage",
                    dataClass: "center aligned",
                    titleClass: "center aligned",
                    width: "150px"
                },
                {
                    name: "non_responders",
                    title: "Non-Responders",
                    dataClass: "center aligned",
                    titleClass: "center aligned",
                    width: "150px"
                }
            ],
            http_options: {
                baseURL: http.defaults.baseURL,
                headers: { "X-Authorization": store.state.token.token },
                transformResponse_old: [(raw) => {
                    try {
                        let data = JSON.parse(raw)

                        return data
                    } catch (error) {
                        console.warn(error)
                        return raw
                    }
                }]
            },
            is_loading: false
        }
    },

    methods: {
        /**
         * Change the pagination page when requested.
         *
         * @param object page Page
         *
         * @return null
         */
        onChangePage (page) {
            this.$refs.facilities_table.changePage(page)
        },

        onLoadData () {
            this.$refs.facilities_table.reload()
        },

        /**
         * Update the pagination component when data is received.
         *
         * @param object paginationData Pagination data
         *
         * @return null
         */
        onPaginationData (paginationData) {
            this.$refs.facilities_table_pagination.setPaginationData(paginationData)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/list-facilities-page/RetiredFacilitiesTab.vue